import { List, ListItem, ListItemButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UserRoles } from "../shared/constants/enums";
import { Heading, WarningDialog } from "../shared/ReusableComponents";
import styles from "./header.module.css";
import * as Nav from "./navs";
import { useDispatch, useSelector } from "react-redux";
import { trackNotesProgress } from "../store/userNotesSlice";

const SideNav = ({
  role,
  leftNavExpandMenu,
}: {
  role: number;
  leftNavExpandMenu: boolean;
}) => {
  //const [activePage, setActivePage] = useState("");
  const [navs, setNavs] = useState<any>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const userNotes = useSelector(
    (state: any) => state.userNotesSlice.editingInProgress
  );
  const [path, setPath] = useState("/");

  useEffect(() => {
    const navItems =
      role === UserRoles.SUPER_USER
        ? Nav.AdminNav
        : role === UserRoles.NURSING_STUDENT
        ? Nav.StudentNav
        : role === UserRoles.SUBJECT_COORDINATOR
        ? Nav.CoordinatorNav
        : Nav.TutorNav; // TUTOR

    setNavs(navItems);
    // const homePath = navItems[0]?.path;
    // if (!activePage && homePath) {
    //   //navigate(homePath);
    //   //setActivePage(homePath);
    // }
  }, [role]);

  const navHandler = (item: any) => {
    setPath(item.path);
    if (userNotes) {
      //open warning popup
      setDialogOpen(true);
    } else {
      //navigate to given link
      navigate(item.path);
    }
    //setActivePage(item.path);
  };

  const handleConfirm = () => {
    dispatch(trackNotesProgress(false));
    setDialogOpen(false);
    navigate(path);
  };

  useEffect(() => {
    dispatch(trackNotesProgress(false));
  }, []);

  return (
    <>
      <List>
        {navs.map((item: any, index: number) => (
          <ListItem
            disableGutters={true}
            key={index}
            disablePadding
            onClick={() => navHandler(item)}
            className={
              item.path === location.pathname.split("/")[2] ||
              item.path === location.pathname ||
              (item.sub_path &&
                item.sub_path === location.pathname.split("/")[2])
                ? styles.activeListItem
                : ""
            }
          >
            <ListItemButton
              disableRipple
              disableGutters={true}
              sx={{
                flexDirection: leftNavExpandMenu ? "column" : "row",
                textAlign: leftNavExpandMenu ? "center" : "",
                mb: "0.125rem",
                pl: leftNavExpandMenu ? "" : "0.1rem",
                columnGap: 1,
                width: leftNavExpandMenu ? "140px" : "",
              }}
            >
              <span
                style={{
                  marginLeft: leftNavExpandMenu ? "" : "1.375rem",
                  marginTop: "0.188rem",
                }}
              >
                {item.icon}
              </span>

              {!leftNavExpandMenu && (
                <Heading text={item.title} type="body1" isBold />
              )}
              {leftNavExpandMenu && (
                <Heading
                  text={item.title}
                  type="body1"
                  isBold
                  style={{
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    textAlign: "center",
                    maxWidth: "120px",
                  }}
                />
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <WarningDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        text="You have unsaved notes, please save before leaving this page."
        handleConfirm={handleConfirm}
      />
    </>
  );
};

export default SideNav;
